import { Modal, Stack, Text, Group, Button, List, ThemeIcon } from '@mantine/core';
import { AlertTriangle } from 'react-feather';

const SURVEY_TYPE_LABELS: Record<string, string> = {
  matching_form: 'Matching Form',
  post_session: 'Post Session',
  midpoint: 'Midpoint',
  endpoint: 'Endpoint',
};

interface ClearConfigurationModalProps {
  opened: boolean;
  onClose: () => void;
  onConfirm: () => void;
  surveyType: string;
  loading?: boolean;
}

export function ClearConfigurationModal({
  opened,
  onClose,
  onConfirm,
  surveyType,
  loading = false,
}: ClearConfigurationModalProps) {
  const label = SURVEY_TYPE_LABELS[surveyType] || surveyType;

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={
        <Group gap="sm">
          <ThemeIcon color="red" variant="light" size="lg" radius="xl">
            <AlertTriangle size={18} />
          </ThemeIcon>
          <Text fw={600}>Clear {label} Configuration?</Text>
        </Group>
      }
      size="md"
      centered
    >
      <Stack gap="md">
        <Text size="sm">
          This will clear the survey configuration for <Text component="span" fw={600}>{label}</Text>, including:
        </Text>

        <List size="sm" spacing="xs">
          <List.Item>Selected form and email content</List.Item>
          <List.Item>Any scheduled survey emails will be cancelled</List.Item>
          <List.Item>Previously sent surveys are not affected</List.Item>
        </List>

        <Group justify="flex-end" gap="sm" mt="md">
          <Button variant="default" onClick={onClose} disabled={loading}>
            Cancel
          </Button>
          <Button color="red" onClick={onConfirm} loading={loading}>
            Clear Configuration
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
}
